import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { data, dataMysql, extract, pontoVirgula } from '../../util/util';
import Data from '../../components/Data';
import { toast } from 'react-toastify';
import ReactSelect from '../../components/ReactSelect';
import InputMask from 'react-input-mask';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoAgenda({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({ eventoagenda: [] });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const calculaTotal = () => {
    }//calculaTotal

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/evento/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: []
                });
                setDados(dadosRecebidos);
            }).catch(err => {
                // console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            dados.eventoagenda = [];
            setIsLoading(false);
        }
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        //converte todas as datas para mysql
        if (dados.eventoagenda)
            dados.eventoagenda.forEach((registro, index) => {
                dados.eventoagenda[index].data = dataMysql(dados.eventoagenda[index].data);
            });

        //update
        api({
            method: 'put',
            action: '/eventoAgenda/' + id,
            token: token,
            data: {
                ...dados,
                ...{ empresa: empresa }
            }
        })
            .then(function (response) {
                toast.success("Dados salvos com sucesso!");
                history.push("/evento");
            })
            .catch(function (error) {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Agenda</h1></div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting} onClick={salvar}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </div>

                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Evento">
                                <FinInput readOnly type="text" value={dados.nome || ''} />
                            </FinField>
                        </div>
                    </div>

                    <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 50 }}></th>
                                        <th style={{ width: 160 }}>Data</th>
                                        <th style={{ width: 120 }}>Hora</th>
                                        <th style={{ minWidth: 200 }}>Palestrante</th>
                                        <th style={{ width: 140 }}>Participantes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dados.eventoagenda ? dados.eventoagenda.map((row, rowIndex) => (
                                        <React.Fragment key={rowIndex}>
                                            <tr>
                                                <td style={{ verticalAlign: 'top', paddingTop: 12 }}>
                                                    <button
                                                        type="button"
                                                        className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                                                        title="Remover"
                                                        onClick={() => {
                                                            dados.eventoagenda.splice(rowIndex, 1);
                                                            setDados({ ...dados });
                                                        }}
                                                    >
                                                        <FaTrash size={14} />
                                                    </button>
                                                </td>
                                                <td>
                                                    <Data
                                                        value={data(row.data)}
                                                        onChange={(date) => {
                                                            dados.eventoagenda[rowIndex].data = date;
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <InputMask
                                                        mask="99:99"
                                                        className="fin-pp__input"
                                                        style={{ paddingLeft: 14 }}
                                                        placeholder="Hora"
                                                        value={dados.eventoagenda[rowIndex].hora || ''}
                                                        onChange={(e) => {
                                                            dados.eventoagenda[rowIndex].hora = e.target.value;
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <ReactSelect
                                                        value={row.palestrante !== null ? { value: row.palestrante?.id ?? null, label: row.palestrante?.nome ?? null } : null}
                                                        onChange={(e) => {
                                                            dados.eventoagenda[rowIndex].palestrante = {};
                                                            dados.eventoagenda[rowIndex].palestrante.id = e.value;
                                                            dados.eventoagenda[rowIndex].palestrante.nome = e.label;
                                                            setDados({ ...dados });
                                                        }}
                                                        defaultOptions
                                                        loadOptions={(input) => {
                                                            return api({
                                                                method: 'get',
                                                                action: '/produto',
                                                                token: token,
                                                                params: {
                                                                    nome: input,
                                                                    modulo: 'servicoOrcamento',
                                                                    superiorIsNull: true
                                                                }
                                                            })
                                                                .then(response => {
                                                                    let options = response.data.data.map((registro) => {
                                                                        return { value: registro.id, label: registro.codigo + ' - ' + registro.nome };
                                                                    });
                                                                    return options;
                                                                })
                                                                .catch(function (error) {
                                                                    //console.log(error);
                                                                });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="fin-pp__input"
                                                        style={{ paddingLeft: 14 }}
                                                        placeholder="Participantes"
                                                        value={pontoVirgula(dados.eventoagenda[rowIndex].participantes)}
                                                        onChange={(e) => {
                                                            dados.eventoagenda[rowIndex].participantes = e.target.value;
                                                            calculaTotal();
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={5}>
                                                    <textarea
                                                        className="fin-pp__input"
                                                        placeholder="Tópico"
                                                        style={{ height: 'auto', padding: '10px 14px', minHeight: 80, width: '100%' }}
                                                        value={dados.eventoagenda[rowIndex].topico || ''}
                                                        onChange={(e) => {
                                                            dados.eventoagenda[rowIndex].topico = e.target.value;
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    )) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary"
                            onClick={() => {
                                dados.eventoagenda.push({});
                                setDados({ ...dados });
                            }}
                        >
                            <FaPlus size={14} /> Adicionar Item
                        </button>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
